import { Navigate } from 'react-router';
import { useAppSelector } from '../../../import';
import { checkPermission } from '../../../utils/permissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission?: {
    section: string;
    action: string;
  };
  fallbackPath?: string;
}

const ProtectedRoute = ({ children, requiredPermission, fallbackPath = '/access-denied' }: ProtectedRouteProps) => {
  const { permissions } = useAppSelector((state) => state.auth);

  if (requiredPermission) {
    const hasPermission = checkPermission(
      permissions,
      requiredPermission.section,
      requiredPermission.action
    );

    if (!hasPermission) {
      return <Navigate to={fallbackPath} replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;